// src/components/RolPlayCard.jsx
import React from 'react';
import * as LucideIcons from 'lucide-react';

const RolPlayCard = ({ category, onMouseEnter, onMouseLeave, onCreateChat }) => {
  const {
    key,
    title,
    icon,
    description,
    sparring,
    avatar,
    avatarStack,
    badgeIcon,
    cta,
    bgCircle,
    badge,
  } = category;

  const BadgeIcon = badgeIcon;

  return (
    <div
      className="relative bg-white border border-gray-200 rounded-lg shadow-sm p-4 md:p-6 flex flex-col md:flex-col items-center min-h-[220px] md:min-h-[260px] transition-all duration-150 hover:border-blue-400 hover:shadow-md active:scale-95"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {badge && (
        <div className={`absolute top-2 right-2 text-xs font-bold px-2 py-0.5 rounded-full
          ${badge === 'Nuevo' ? 'bg-blue-100 text-blue-800' : 'bg-gray-200 text-gray-700'}`}>
          {badge}
        </div>
      )}

      {key !== "presentacion_critica" ? (
        <div className={`w-12 md:w-16 h-12 md:h-16 rounded-full flex items-center justify-center mx-auto mb-2 md:mb-3 ${bgCircle}`}>
          <img
            src={avatar}
            alt={title}
            className="w-10 md:w-14 h-10 md:h-14 rounded-full object-cover"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center mx-auto mb-2 md:mb-3">
          <img
            src={avatarStack[0]}
            alt="Naira IA"
            className="w-10 md:w-14 h-10 md:h-14 rounded-full border-2 border-white object-cover"
          />
          <img
            src={avatarStack[1]}
            alt="Artemis IA"
            className="w-10 md:w-14 h-10 md:h-14 rounded-full border-2 border-white object-cover -ml-2 md:-ml-3"
          />
        </div>
      )}

      <h3 className="text-sm md:text-lg font-bold text-gray-900 tracking-wide text-center uppercase leading-tight flex items-center justify-center gap-2">
        {icon && <span className="text-blue-600">{icon}</span>}
        {title}
      </h3>
      <p className="text-gray-600 text-xs md:text-sm mt-1 md:mt-2 text-center flex-1 line-clamp-3 md:line-clamp-none">{description}</p>
      
      <span className="flex items-center gap-1 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-full px-2 md:px-3 py-1 mt-2 md:mt-3 mb-2">
        {BadgeIcon && <BadgeIcon className="w-3 md:w-4 h-3 md:h-4 text-gray-500" />}
        <span className="hidden sm:inline">{sparring}</span>
        <span className="sm:hidden">IA</span>
      </span>
      
      <button
        className="mt-auto w-full py-3 md:py-2 bg-blue-600 text-white font-bold uppercase rounded-lg shadow hover:bg-blue-700 transition-all duration-150 active:scale-95 min-h-[44px] text-sm md:text-base"
        onClick={() => onCreateChat(key)}
      >
        <span className="hidden sm:inline">{cta}</span>
        <span className="sm:hidden">INICIAR</span>
      </button>
    </div>
  );
};

export default RolPlayCard;
